export default __webpack_public_path__ + "static/media/email-sent.db7b538f.svg";